import { Injectable } from "@angular/core";
import { Directory } from "@capacitor/filesystem";
import { LoadingService } from "../../../../services/loading.service";
import { PlatformService } from "../../../../services/platform.service";
import { FilesystemService } from "../../../filesystem/services/filesystem.service";
import { LoggerService } from "../../../logger/services/logger.service";
import { LocalDatabaseProviderService } from "../../../sqlite/services/providers/local-database-provider.service";
import { RemoveInvalidSqlDatabasesPatchBase } from "../../models/patches/remove-invalid-sql-databases-patch-base";

@Injectable()
export class RemoveInvalidStocksPatch extends RemoveInvalidSqlDatabasesPatchBase {
	//#region METHODS

	constructor(
		psvcLoading: LoadingService,
		psvcFilesystem: FilesystemService,
		psvcLogger: LoggerService,
		psvcPlatform: PlatformService,
		private readonly isvcLocalDatabaseProvider: LocalDatabaseProviderService
	) {
		super(psvcLoading, psvcFilesystem, psvcLogger, psvcPlatform, "Suppression des stocks obsolètes");
	}

	protected override getSqlDatabasesPath(): string {
		return this.isvcLocalDatabaseProvider.mobileAppDatabasesPath;
	}

	protected override getSqlDatabasesDirectoryPath(): Directory {
		return LocalDatabaseProviderService.mobileAppDatabasesDirectory;
	}

	protected override getDatabasesPrefix(): string {
		return "stock-";
	}

	protected override getDatabaseNameRegex(): RegExp {
		return /(stock-\d+)-(\d+)/; // stock-{{warehouseId}}-{{version}} -> "stock-123456-42".
	}

	//#endregion
}
